<template>
    <div class="requirements">
        <div class="requirements__text">{{ title }}</div>
        <div class="requirements__items">
            <div v-for="(item, index) in items"
                :key="index"
                class="requirements__item"
            >
                <i class="icon-check" />

                <span>{{ text(item)[0] }}</span>

                <div v-if="text(item)[1]"
                    class="requirements__hint"
                >
                    <i class="icon-info" />
                    <span>{{ text(item)[1] }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'kyc-requirements',
    props: {
        title: {
            type: String,
            default: '',
        },
        items: {
            type: Array,
            default: () => ([]),
        },
    },
    methods: {
        text(item) {
            return item.split(/\ \(|\)/g); // eslint-disable-line
        },
    },
};
</script>

<style lang="scss" scoped>
.requirements {
    padding-top: 2rem;

    &__text {
        font-size: 1.1rem;
        line-height: 1.8rem;
        font-weight: 700;
        color: $blue-charcoal-color;
        padding: 1.1rem 0;
    }

    &__items {
        display: flex;
        flex-wrap: wrap;
    }

    &__item {
        position: relative;
        display: flex;
        font-size: 1.4rem;
        margin-right: 2rem;
        margin-bottom: 2rem;
        min-width: 100%;

        @include min-width (md) {
            font-size: 1.2rem;
            min-width: 31%;
        }

        @include min-width(lg) {
            min-width: unset;
            font-size: 1.4rem;
        }

        .icon-check {
            color: $lima-color;
            margin-right: 1rem;
            font-size: 1.8rem;
        }
    }

    &__hint {
        position: initial;
        right: -1.5rem;
        text-align: right;

        @include min-width(md) {
            position: absolute;
            width: 100%;
        }

        .icon-info {
            color: $azure-radiance-color;
            font-size: 1.3rem;
            position: relative;
            cursor: pointer;
            top: -0.5rem;
        }

        span {
            opacity: 0;
            position: absolute;
            white-space: nowrap;
            background: $dusty-gray-color;
            color: $white-color;
            border-radius: 0.2rem;
            padding: 0 0.3rem;
            top: -2.5rem;
            left: 0;
            transition: opacity 0.5s ease;

            @include max-width(sm) {
                font-size: 1rem;
                left: -3.5rem;
            }

            @include min-width(md) {
                left: -7.5rem;
            }
        }

        i:hover + span {
            opacity: 1;
        }
    }
}
</style>